import { CalendarComponent } from "components/Calendar"
import { Footer } from "components/Footer"
import { Inputs } from "components/Input"

export const Teste = () => {
    return (
        <div>
            <CalendarComponent />
        </div>
    )
}